import { Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import SVGInline from 'react-svg-inline';
import { useVcmsQuery } from '../../hooks/useVcms';
import { AllDone } from './AllDone';
import WidgetListItem from './WidgetListItem';
import { getDaysDifference } from './utils';

const checkCircleIcon = require('../../../images/check-circle.svg.raw');

const VcmWidget = ({ institute }) => {
  const { data: vcms, isPending } = useVcmsQuery();

  const vcmsAsWidgetFormat = React.useMemo(() => {
    if (!vcms || vcms?.length === 0) return [];

    return vcms.map((vcm) => {
      const overdueDays = getDaysDifference(vcm.status_updated_at || vcm.created_at)
      
      return {
        id: vcm.id,
        name: vcm.owner_user?.full_name || 'Unknown User',
        updatedAt: vcm.status_updated_at || vcm.created_at,
        overdueDays: overdueDays > 0 ? overdueDays : 0
      };
    });
  }, [vcms]);

  const overdueCount = React.useMemo(() => {
    const threshold = institute?.vcm_warning_days;

    return vcmsAsWidgetFormat.filter(
      (p) => threshold && (p.overdueDays || 0) >= threshold
    ).length;
  }, [institute, vcmsAsWidgetFormat]);

  const totalCount = vcms?.length;

  const onItemClick = React.useCallback((vcm) => {
    if (vcm) {
      window.location.href = `/admin#/vcm/${vcm.id}`;
    }
  }, []);

  return (
    <Paper style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '12px',
          borderBottom: '1px solid #eee'
        }}
      >
        <Typography
          variant="h6"
          style={{ marginRight: 12, fontSize: 16, fontWeight: '600' }}
        >
          VCMs
        </Typography>
        {isPending ? (
          <div></div>
        ) : !totalCount ? (
          <div style={{ width: 20, height: 20, alignItems: 'center' }}>
            <SVGInline svg={checkCircleIcon} />
          </div>
        ) : (
          <span
            style={{
              background: '#F5F5F5',
              borderRadius: 8,
              padding: '4px 8px',
              fontWeight: 500,
              fontSize: 13,
              color: '#1F1F1F',
              marginLeft: 0,
              display: 'inline-block'
            }}
          >
            {overdueCount}/{totalCount}{totalCount === 25 ? '+' : ''}
          </span>
        )}
      </div>
      <div style={{ maxHeight: 360, overflowY: 'auto', padding: 0, margin: 0 }}>
        {isPending ? (
          <Typography style={{marginLeft: 16}}>Loading...</Typography>
        ) : !totalCount ? (
          <AllDone />
        ) : (
          vcmsAsWidgetFormat.map((vcm, idx) => (
            <WidgetListItem
              key={vcm.id}
              createdAt={vcm.updatedAt}
              name={vcm.name}
              overdueDays={vcm.overdueDays}
              onButtonClick={() => onItemClick(vcm)}
              disableDivider={idx === vcmsAsWidgetFormat.length - 1}
              warningThreshold={institute?.vcm_warning_days || 7}
              overdueThreshold={institute?.vcm_overdue_days || 14}
            />
          ))
        )}
      </div>
    </Paper>
  );
};

export default VcmWidget;
